import React from "react"
import ReactPaginate from "react-paginate"
import PropTypes from "prop-types"
import { t } from "i18next"

const Paginate = props => {
  const {
    size,
    count,
    onPageChange,
    pageRangeDisplayed = 3,
    forcePage,
    ...otherProps
  } = props

  return (
    <ReactPaginate
      onPageChange={onPageChange}
      pageRangeDisplayed={pageRangeDisplayed}
      pageCount={Math.ceil(count / size)}
      forcePage={forcePage - 1}
      breakLabel="..."
      nextLabel={t("next")}
      previousLabel={t("previous")}
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName="pagination"
      activeClassName="active"
      renderOnZeroPageCount={null}
      {...otherProps}
    />
  )
}
Paginate.propTypes = {
  size: PropTypes.number,
  count: PropTypes.number,
  pageCount: PropTypes.number,
  pageRangeDisplayed: PropTypes.number,
  onPageChange: PropTypes.func,
  forcePage: PropTypes.number,
}
export default Paginate
